<template>
<div style="display: flex;justify-content: space-between;align-items: start">
  <div>
    <div class="medical-form">
    <button class="button-2" @click="tab ='AtbForm'">ATB form</button>
    <button @click="tab ='PatientForm'">Patient form</button>
    <PatientForm  v-if="tab === 'PatientForm'"></PatientForm>
    <AtbForm v-if="tab === 'AtbForm'"></AtbForm>
    
    <div v-if="loading" style="color: blue; font-weight: 500; margin: 10px 0px 0px 0px; height:10px; text-align: center;">
      Fetching data...
    </div>
    <div v-else style="color: red;font-weight: 500;margin: 10px 0px 0px 0px;height:10px">
      {{ errorMessage }}
    </div>
      </div>
      <AdminForm></AdminForm>
      <div style="display: flex; flex-direction: column; align-items: center; margin-top: 50px; gap: 6px;">
        <button @click="downloadPDF(store)" class="download-button">
          <span class="download-icon">⬇️</span>
          <span>Download report (PDF)</span>
        </button>
        <div class="download-hint">Saves a printable PDF with data and interpretation</div>
      </div>
  </div>
      <div class="second-panel">
        <DataBox></DataBox>
        
        <!-- Disclaimer Component -->
  
        
        <InterBox></InterBox>
      </div>
</div>
<div style="display: flex; justify-content: center; align-items: center;">
  <DisclaimerBox />
</div>
</template>

<script setup>
import { computed, onUnmounted, ref, watch, onMounted } from "vue"
import api from "@/api/axios"
import { useTestStore } from "@/stores/testStore";
import { downloadPDF } from "@/utils/htmlPdfUtils";

import AtbForm from "@/components/AtbForm.vue";
import PatientForm from "@/components/PatientForm.vue";
import AdminForm from '@/components/AdminForm.vue'
import DataBox from "@/components/DataBox.vue";
import InterBox from "@/components/InterBox.vue";
import DisclaimerBox from '@/components/DisclaimerBox.vue';

const store = useTestStore();

const loading = ref(false);
const tab = ref("AtbForm")
const errorMessage = ref(" ")

const getData = async () => {
  if (store.antibioticText == "" || store.speciesText == "") {
    errorMessage.value = "please select an antibiotic and a species"
    return null
  }
  
  try {
    loading.value = true;
    errorMessage.value = ""
    
    const [responseMIC, responseFup] = await Promise.all([
      api.get(`/test/${store.antibioticValue}/${store.speciesText}`),
      api.get(`/retrieve-fup/${store.antibioticText}`)
    ])
    console.log(responseFup.data.fup)
    store.imageUrl = responseMIC.data.url
    console.log("row values", responseMIC.data.rowValues)
    if (responseMIC.data.rowValues.length != 0) {
      store.rowValues = responseMIC.data.rowValues;
      store.ecoff = parseFloat(store.rowValues[21].replace(/[^\d.,-]/g, '').replace(',', '.'));
      store.errorMIC = null;
    }
    else {
      store.rowValues = Array(23).fill(0);
      store.ecoff = 0;
      store.errorMIC = "no MIC data for this combination";
    }

    if (responseFup.data.success == true){
      store.predictedFup = responseFup.data.fup;
    }
    else{
      store.predictedFup = null;
    }
    
    // Note: intervalData is now accessed via store.currentAtbDataRow getter
    // No need to store individual interval data since we have the complete sheet
  } catch (error) {
    console.error('Error fetching data:', error);
    errorMessage.value = "Error fetching data. Please try again.";
  } finally {
    loading.value = false;
  }
}

// Function to validate if the current selections are complete/valid
const isValidSelection = () => {
  // Check if the antibiotic text matches exactly an item in atbSpeciesPairInfo
  const antibioticRow = store.atbSpeciesPairInfo.find(row => row["atb"] === store.antibioticText);
  
  if (!antibioticRow) {
    return false; // Antibiotic not found
  }
  
  // Check if the species exists as a key in the antibiotic object
  const isValidSpecies = store.speciesText && 
                        store.speciesText !== "" && 
                        store.speciesText !== "select an antibiotic first" &&
                        antibioticRow.hasOwnProperty(store.speciesText);
  
  return isValidSpecies;
};

// Watch for changes in antibiotic and species selection to auto-fetch data
watch([() => store.antibioticText, () => store.speciesText], ([newAntibioticText, newSpeciesText], [oldAntibioticText, oldSpeciesText]) => {
  // Only proceed if at least one value has changed
  if (newAntibioticText !== oldAntibioticText || newSpeciesText !== oldSpeciesText) {
    if (isValidSelection()) {
      getData();
    } else {
      // Clear previous results if selection becomes invalid
      errorMessage.value = "";
      store.imageUrl = "";
      store.rowValues = Array(23).fill(0);
      store.ecoff = 0;
      store.predictedFup = null;
      store.errorMIC = null;
    }
  }
}, { immediate: false });

onMounted( async () => {
  const [dfResponse, atbDataResponse] = await Promise.all([
    api.get("/get-df"),
    api.get("/getAtbDataSheet")
  ]);
  
  store.atbSpeciesPairInfo = dfResponse.data;
  store.atbDataSheet = atbDataResponse.data;
})

</script>

<style>

.medical-form {
  padding: 10px 10px 50px 10px;
  margin-left: 30px;
  border: rgb(204, 161, 161) 3px solid;
  border-radius: 15px;
}





table {
  color: #212529;
  margin-bottom: 1rem;
  width: 100%;
}
table-bordered, .table-bordered td, .table-bordered th {
    border: 1px solid #dee2e6;
}

table {
    display: table;
    border-collapse: separate;
    box-sizing: border-box;
    text-indent: initial;
    unicode-bidi: isolate;
    border-spacing: 2px;
    border-color: gray;
}

.download-button {
  background-color: #4CAF50;
  color: white;
  border: none;
  padding: 10px 16px;
  border-radius: 6px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-weight: 600;
}

.download-button:hover {
  background-color: #43A047;
}

.download-icon {
  font-size: 16px;
}

.download-hint {
  font-size: 12px;
  color: #6c757d;
}

</style>
